import React from 'react';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { COLOR_PRIMARY_1 } from 'src/utils/colors';

const RecentlyAddedChip = ({ noShadow }: { noShadow?: boolean }) => {
  return (
    <Tooltip title="Not enough historical data available for this listing yet. This listing was added on Airbnb within the last 3 months or recently captured by our system. This property data will not be considered in the market statistics.">
      <Chip
        label="Recently Added"
        sx={{
          backgroundColor: '#ffff',
          color: COLOR_PRIMARY_1,
          '&:hover': { cursor: 'pointer' },
          boxShadow: noShadow
            ? 'none'
            : '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)',
          border: noShadow ? `1px solid ${COLOR_PRIMARY_1}` : 'none',
        }}
      />
    </Tooltip>
  );
};

const RecentlyAddedClockIcon = () => {
  return (
    <Tooltip title="Not enough historical data available for this listing yet. This listing was added on Airbnb within the last 3 months or recently captured by our system.">
      <AccessTimeIcon sx={{ color: COLOR_PRIMARY_1 }} />
    </Tooltip>
  );
};

export { RecentlyAddedChip, RecentlyAddedClockIcon };
